export async function getServiceSlug(_ref) {
  var _url;
  let {
    wixCodeApi,
    pageName
  } = _ref;
  let sitePageName = (_url = wixCodeApi.site.currentPage.url) == null ? void 0 : _url.substring(1).toLowerCase();
  const locationPaths = wixCodeApi.location.path.map(subPath => subPath.toLowerCase());
  if (!sitePageName && wixCodeApi.window.viewMode.toLowerCase() === 'site' && wixCodeApi.site.currentPage.type === 'lightbox') {
    sitePageName = locationPaths[0];
  }
  let sitePageNameIndex = locationPaths.indexOf(sitePageName);
  const isSitePageNameExistInPath = sitePageNameIndex !== -1;
  if (!isSitePageNameExistInPath && wixCodeApi.window.viewMode.toLowerCase() === 'preview') {
    sitePageNameIndex = 1;
  }
  const isServiceSlugExistsInPath = isSitePageNameExistInPath && sitePageNameIndex !== wixCodeApi.location.path.length - 1;
  let serviceSlug = isServiceSlugExistsInPath ? wixCodeApi.location.path[sitePageNameIndex + 1] : '';
  const shouldFixProblematicSiteStructureInPreview = wixCodeApi.window.viewMode.toLowerCase() === 'preview' && !isSitePageNameExistInPath && wixCodeApi.location.path.length === 1 && locationPaths[0] !== pageName;
  const siteWithRouterPage = wixCodeApi.site.currentPage.prefix;
  if (shouldFixProblematicSiteStructureInPreview || siteWithRouterPage) {
    serviceSlug = wixCodeApi.location.path[0];
  }
  if (serviceSlug) {
    serviceSlug = decodeURI(serviceSlug);
  }
  return serviceSlug;
}
//# sourceMappingURL=getServiceSlug.js.map